// ThemeName is a union of the `name` value from each theme file
export const ThemeNames = Object.freeze({
    GoodLifePlus: 'good-life-plus',
    Lions: 'lions',
    Rangers: 'rangers',
    Saints: 'saints',
    TrueNorth: 'true-north',
});
export var SiteSlug;
(function (SiteSlug) {
    SiteSlug["GoodLifePlus"] = "good-life-plus";
    SiteSlug["Rangers"] = "rangers-prizes";
    SiteSlug["Saints"] = "saints-prizes";
    SiteSlug["Lions"] = "lions-prizes";
    SiteSlug["TrueNorth"] = "true-north-prizes";
})(SiteSlug || (SiteSlug = {}));
export var ThemeType;
(function (ThemeType) {
    ThemeType["Default"] = "default";
    ThemeType["Club"] = "club";
    ThemeType["Subscription"] = "subscription";
})(ThemeType || (ThemeType = {}));
export var ThemeCurrency;
(function (ThemeCurrency) {
    ThemeCurrency["GBP"] = "GBP";
    ThemeCurrency["EUR"] = "EUR";
    ThemeCurrency["CAD"] = "CAD";
})(ThemeCurrency || (ThemeCurrency = {}));
